import { FeedbackRecognitionRequestTypes } from 'Shared/constants/types';
import { getFirstName } from 'Shared/helpers';

function getFeedbackTitle(currentUserIsCreator, currentUserIsReceiver, creatorName, receiverName) {
  const creator = currentUserIsCreator ? 'Your' : `${creatorName}'s`;
  const receiver = currentUserIsReceiver ? 'you' : receiverName;
  return `${creator} feedback for ${receiver}`;
}

function getRecognitionTitle(currentUserIsCreator, currentUserIsReceiver, creatorName, receiverName) {
  const creator = currentUserIsCreator ? 'You' : creatorName;
  const receiver = currentUserIsReceiver ? 'you' : receiverName;
  return `${creator} gave ${receiver} kudos`;
}

export function getTitle({ requestType, receiver, creator, currentUserId, workspaceName }) {
  const currentUserIsCreator = currentUserId === creator.id;
  const currentUserIsReceiver = currentUserId === receiver?.id;

  return requestType === FeedbackRecognitionRequestTypes.feedback
    ? getFeedbackTitle(
        currentUserIsCreator,
        currentUserIsReceiver,
        creator?.firstName || creator?.email,
        receiver?.firstName || receiver?.email || getFirstName(workspaceName)
      )
    : getRecognitionTitle(
        currentUserIsCreator,
        currentUserIsReceiver,
        creator?.firstName || creator?.email,
        receiver?.firstName || receiver?.email || getFirstName(workspaceName)
      );
}
